import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import {
  MAT_COLOR_FORMATS,
  NgxMatColorPickerModule,
  NGX_MAT_COLOR_FORMATS,
} from "@angular-material-components/color-picker";

import { FlexLayoutModule } from "@angular/flex-layout";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatTableModule } from "@angular/material/table";
import { MatSortModule } from "@angular/material/sort";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatInputModule } from "@angular/material/input";
import { MatTabsModule } from "@angular/material/tabs";
import { MatSelectModule } from "@angular/material/select";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatCardModule } from "@angular/material/card";
import { MatListModule } from "@angular/material/list";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatDialogModule } from "@angular/material/dialog";
import { MatChipsModule } from "@angular/material/chips";

import { ProductDetailComponent } from "./product-detail/product-detail.component";
import { ProductListComponent } from "./product-list/product-list.component";
import { BarcodesListComponent } from "./barcodes-list/barcodes-list.component";
import { PacksListComponent } from "./packs-list/packs-list.component";
import { ProductSuppliersListComponent } from "./suppliers-list/product-suppliers-list.component";
import { ProductSuppliersDialogComponent } from "./dialogs/product-suppliers/product-suppliers-dialog.component";

import { ProductRoutingModule } from "./product-routing.module";
import { CustomTableModule } from "src/app/shared/modules/custom-table/custom-table.module";
import { TopCardMaterialModule } from "src/app/shared/modules/top-card-material/top-card-material.module";
import { FormatPipe } from "../../shared/pipes/formatPipe";
import { CategoriesModule } from "src/app/shared/modules/categories/categories.module";
import { PropertiesModule } from "src/app/shared/modules/properties/properties.module";
import { SelectionListModule } from "src/app/shared/modules/selection-list/selection-list.module";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    ProductRoutingModule,
    CustomTableModule,
    TopCardMaterialModule,
    NgxMatColorPickerModule,
    MatPaginatorModule,
    MatTableModule,
    MatSortModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatGridListModule,
    MatInputModule,
    MatTabsModule,
    MatSelectModule,
    MatCheckboxModule,
    MatCardModule,
    MatListModule,
    MatProgressBarModule,
    MatSidenavModule,
    MatAutocompleteModule,
    MatDialogModule,
    MatChipsModule,
    FlexLayoutModule,
    CategoriesModule,
    PropertiesModule,
    SelectionListModule,
  ],
  providers: [
    { provide: MAT_COLOR_FORMATS, useValue: NGX_MAT_COLOR_FORMATS },
    FormatPipe,
  ],
  declarations: [
    ProductDetailComponent, 
    ProductListComponent, 
    BarcodesListComponent,
    PacksListComponent,
    ProductSuppliersListComponent,
    ProductSuppliersDialogComponent,
  ],
})
export class ProductModule {}
